<template>
  <van-dialog
    title="保存下方二维码，分享结果"
    v-model="dialogVisible"
    message-align="center"
    @confirm="handleClose"
  >
    <div style="text-align: center;"><img :src="url" /></div>
  </van-dialog>
</template>
<script>
import { Dialog } from "vant";
import { obtainServerQrCodeUrl } from "@/utils/LinkHelper";

export default {
  name: "share-qrcode-dialog-mobile",
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  props: {
    visible: Boolean,
    shareUrl: String,
  },
  computed: {
    dialogVisible: {
      get() {
        return this.$props["visible"];
      },
      set(value) {
        if (!value) {
          this.$emit("on-close");
        }
      },
    },
    url() {
      if (this.shareUrl) {
        return obtainServerQrCodeUrl(this.shareUrl);
      }
      return "";
    },
  },
  methods: {
    handleClose() {
      this.$emit("on-close");
    },
  },
};
</script>
